export default "__VITE_ASSET__dd8b5595__$_?nuxt_component=async&nuxt_component_name=SvgoHelp2952980__"